import { useState, useEffect, useRef } from 'react';

const Reveal = ({ children, animation = 'fade-up', delay = 0, duration = 900, className = '', style = {} }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const getStyle = () => {
    const ease = 'cubic-bezier(0.16, 1, 0.3, 1)';
    const base = {
      transition: `opacity ${duration}ms ${ease} ${delay}ms, transform ${duration}ms ${ease} ${delay}ms, clip-path ${duration}ms ${ease} ${delay}ms`,
      willChange: 'opacity, transform',
    };
    if (isVisible) {
      return { ...base, opacity: 1, transform: 'translate3d(0, 0, 0) scale(1) skewY(0deg)', clipPath: 'inset(0% 0% 0% 0%)' };
    }
    switch (animation) {
      case 'fade-up':    return { ...base, opacity: 0, transform: 'translate3d(0, 56px, 0)', clipPath: 'inset(0% 0% 8% 0%)' };
      case 'fade-down':  return { ...base, opacity: 0, transform: 'translate3d(0, -56px, 0)' };
      case 'fade-left':  return { ...base, opacity: 0, transform: 'translate3d(64px, 0, 0)', clipPath: 'inset(0% 0% 0% 8%)' };
      case 'fade-right': return { ...base, opacity: 0, transform: 'translate3d(-64px, 0, 0)', clipPath: 'inset(0% 8% 0% 0%)' };
      case 'scale-up':   return { ...base, opacity: 0, transform: 'scale(0.92) translate3d(0, 20px, 0)' };
      case 'skew-up':    return { ...base, opacity: 0, transform: 'translate3d(0, 40px, 0) skewY(3deg)', clipPath: 'inset(0% 0% 12% 0%)' };
      case 'zoom':       return { ...base, opacity: 0, transform: 'scale(1.06)', clipPath: 'inset(4% 4% 4% 4%)' };
      case 'slide-up':   return { ...base, opacity: 0, transform: 'translate3d(0, 80px, 0)', clipPath: 'inset(0% 0% 15% 0%)' };
      default:           return { ...base, opacity: 0, transform: 'translate3d(0, 56px, 0)' };
    }
  };

  return (
    <div ref={ref} className={className} style={{ ...getStyle(), ...style }}>
      {children}
    </div>
  );
};

export default Reveal;
